import image1 from "../../assets/home/carousel/carousel-image/INLT.png"
import image2 from "../../assets/home/carousel/carousel-image/Poster_VFX_ICW.jpg"
import image3 from "../../assets/home/carousel/carousel-image/Poster_VFX_Alert.jpg"
import image4 from "../../assets/home/carousel/carousel-image/Poster_GFX_500Days.jpg"
import image5 from "../../assets/home/carousel/carousel-image/HLS.png"
import image6 from "../../assets/home/carousel/carousel-image/Poster_VFX_CIGAW.jpg"

import video1 from "../../assets/home/carousel/carousel-video/INLT.mp4"
import video2 from "../../assets/home/carousel/carousel-video/Video_VFX_ICW.mp4"
import video3 from "../../assets/home/carousel/carousel-video/Video_VFX_Alert.mp4"
import video4 from "../../assets/home/carousel/carousel-video/Video_GFX_500Days.mp4"
import video5 from "../../assets/home/carousel/carousel-video/HLS.mp4"
import video6 from "../../assets/home/carousel/carousel-video/Video_VFX_CIGAW.mp4"

const black = "#121212";
const white = "#F5F5F5";
const yellow = "#D8C535";
const blue = "#00C0C0";
const pink = "#C000C0";
const yellowFilter = "invert(71%) sepia(50%) saturate(542%) hue-rotate(13deg) brightness(97%) contrast(99%)";
const blueFilter = "invert(62%) sepia(32%) saturate(4103%) hue-rotate(137deg) brightness(93%) contrast(100%)";
const pinkFilter = "invert(15%) sepia(92%) saturate(3211%) hue-rotate(289deg) brightness(102%) contrast(128%)";

export const dataCarousel = [
  {
    "id": 1,
    "title": "It's Not Like That",
    "description": `Freshly divorced Lori and recently widowed minister Malcolm,
    friends with teens, navigate singlehood while questioning if their longstanding
    bond hints at a romantic future.`,
    "image": image1,
    "video": video1,
    "colour": blue,
    "colourFilter": blueFilter,
    // "colour": "#B7B1AD",
  },
  {
    "id": 2,
    "title": "In Cold Water",
    "description": `Canadian teacher Laura Letts-Beckett drowned in 2008. 
      Her husband Peter claimed an accident, but police suspected 
      he murdered her in the BC wilderness. Was it a tragic mishap or cold-blooded crime?`,
    "image": image2,
    "video": video2,
    "colour": blue,
    "colourFilter": blueFilter,
    // "colour": "#449AAF",
  },
  {
    "id": 3,
    "title": "Alert: Missing Persons Unit",
    "description":`Follows Nikki Batista after she joins the Philadelphia Police Department's 
      Missing Person's Unit to help other people find their loved ones at the same time 
      that she is looking for her missing son.`,
    "image": image3,
    "video": video3,
    "colour": yellow,
    "colourFilter": yellowFilter,
    // "colour": "#EDE210",
  },
  {
    "id": 5,
    "title": "Hitler's Last Stand",
    "description": "As the end of WWII approaches, diehard Nazi forces fight to the end to stop Allied armies from freeing Europe.",
    "image": image5,
    "video": video5,
    "colour": yellow,
    "colourFilter": yellowFilter,
    // "colour": "#E7B95E",
  },
  {
    "id": 6,
    "title": "Can I Get a Witness?",
    "description": `In a not so distant future, there is a reality where in order to save the planet, 
      "death is everyone's job", with 50-year-olds taking the sacrifice, while teenage 
      artists need to document it.`,
    "image": image6,
    "video": video6,
    "colour": blue,
    "colourFilter": blueFilter,
    // "colour": "#72BEAC",
  },
    {
    "id": 4,
    "title": "500 Days in the Wild",
    "description": `Dianne Whelan spends six years travelling the entire length of the Trans 
      Canada trail, across land and water trails from sea to sea.`,
    "image": image4,
    "video": video4,
    "colour": pink,
    "colourFilter": pinkFilter,
    // "colour": "#E29C2B",
  },
]